import { getPlayAudioSource } from '@legacy-shared/widgets/core/play';
import type { PlayConfig } from '@legacy-shared/widgets/core/play';

export type AudioFileUsage = {
  kind: 'draft_flow' | 'published_flow' | 'queue_hold_music';
  entityId: string;
  name: string;
};

type FlowNode = { type?: string; data?: { config?: unknown } & Record<string, unknown> };

function collectAudioFileIds(nodes: unknown) {
  const audioFileIds = new Set<string>();

  for (const node of Array.isArray(nodes) ? (nodes as FlowNode[]) : []) {
    if (node.type !== 'play') continue;

    const config = (node.data?.config ?? node.data) as PlayConfig | undefined;

    if (!config || getPlayAudioSource(config) !== 'catalog') continue;

    const audioFileId = config.audioFileId?.trim();

    if (audioFileId) audioFileIds.add(audioFileId);
  }

  return audioFileIds;
}

export function buildAudioFileUsages(
  flows: Array<{ id: string; name: string; nodes: unknown; currentPublication: { nodes: unknown } | null }>,
) {
  const usagesByAudioFile = new Map<string, AudioFileUsage[]>();

  const record = (audioFileId: string, usage: AudioFileUsage) => {
    usagesByAudioFile.set(audioFileId, [...(usagesByAudioFile.get(audioFileId) ?? []), usage]);
  };

  for (const flow of flows) {
    for (const audioFileId of collectAudioFileIds(flow.nodes)) {
      record(audioFileId, { kind: 'draft_flow', entityId: flow.id, name: flow.name });
    }

    for (const audioFileId of collectAudioFileIds(flow.currentPublication?.nodes)) {
      record(audioFileId, { kind: 'published_flow', entityId: flow.id, name: flow.name });
    }
  }

  return usagesByAudioFile;
}

export function usageLabel(usage: AudioFileUsage) {
  if (usage.kind === 'draft_flow') return `Draft flow: ${usage.name}`;
  if (usage.kind === 'published_flow') return `Published flow: ${usage.name}`;

  return `Queue: ${usage.name}`;
}
